import AppModal from "@components/modals/AppModal";
import "@assets/css/mode_tool/translatePointsModal.css";

function AiAudioLanguageModal({
  isOpen,
  languages = [],
  selectedLanguage = "",
  onSelectLanguage,
  pointScope = "all",
  onSelectPointScope,
  onContinue,
  onClose,
}) {
  const availableLanguages = Array.isArray(languages) ? languages : [];

  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title="AI Audio Description"
      size="sm"
      className="mode-route-translate-modal"
    >
      <p>Select the language for the AI audio descriptions.</p>
      {availableLanguages.length ? (
        <fieldset className="mode-route-translate-languages">
          <legend>Available languages</legend>
          {availableLanguages.map((language) => (
            <label key={language.id || language.iso}>
              <input
                type="radio"
                name="ai-audio-description-language"
                value={language.iso}
                checked={selectedLanguage === String(language.iso || "").toLowerCase()}
                onChange={() => onSelectLanguage?.(language.iso)}
              />
              <span>{language.name || String(language.iso).toUpperCase()}</span>
              <small>{String(language.iso || "").toUpperCase()}</small>
            </label>
          ))}
        </fieldset>
      ) : (
        <p>No languages are available for this route.</p>
      )}
      {availableLanguages.length ? (
        <fieldset className="mode-route-translate-languages mode-route-ai-point-scope">
          <legend>Points to generate audio for</legend>
          {[
            ["all", "All points"],
            ["regular", "Regular points only"],
            ["directions", "Direction points only"],
          ].map(([value, label]) => (
            <label key={value}>
              <input
                type="radio"
                name="ai-audio-point-scope"
                value={value}
                checked={pointScope === value}
                onChange={() => onSelectPointScope?.(value)}
              />
              <span>{label}</span>
            </label>
          ))}
        </fieldset>
      ) : null}
      <div className="tour-add-editor-actions">
        <button type="button" className="button-ghost" onClick={onClose}>
          Close
        </button>
        {availableLanguages.length ? (
          <button
            type="button"
            className="button-primary"
            onClick={onContinue}
            disabled={!selectedLanguage}
          >
            Continue
          </button>
        ) : null}
      </div>
    </AppModal>
  );
}

export default AiAudioLanguageModal;
